import type { ModelAddButtonOptions } from "@/modules/model-add-button";

import ProjectCreate from "@/features/Projects/Create";
import ModelAddButton from "@/modules/model-add-button";

const ProjectAddButton = (options: ModelAddButtonOptions) => {
  return (
    <ModelAddButton
      model="project"
      component={<ProjectCreate />}
      {...options}
    />
  );
};

export default ProjectAddButton;
